/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PodcastPlayer_podcast$ref: FragmentReference;
declare export opaque type PodcastPlayer_podcast$fragmentType: PodcastPlayer_podcast$ref;
export type PodcastPlayer_podcast = {|
  +title: string,
  +series: {|
    +coverPhoto: string
  |},
  +downloadUrl: string,
  +$refType: PodcastPlayer_podcast$ref,
|};
export type PodcastPlayer_podcast$data = PodcastPlayer_podcast;
export type PodcastPlayer_podcast$key = {
  +$data?: PodcastPlayer_podcast$data,
  +$fragmentRefs: PodcastPlayer_podcast$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PodcastPlayer_podcast",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SeriesType",
      "kind": "LinkedField",
      "name": "series",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverPhoto",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    }
  ],
  "type": "PodcastType",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'd2ee745ac6292f394b9655a8e9b6d274';

module.exports = node;
